import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClassName = "" }) => (
  <h1 className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          className={`block ${lineClassName}`}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Counter = ({ to, suffix = "", className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);
  return (
    <span ref={ref} className={className}>
      {val}
      {suffix}
    </span>
  );
};

export const SectionHead = ({ index, eyebrow, title, testid }) => (
  <Reveal>
    <div className="flex items-center gap-4">
      <span className="font-condensed text-sm font-bold text-[#F5A800]">{index}</span>
      <span className="h-px w-10 bg-[#F5A800]/50" />
      <span className="eyebrow">{eyebrow}</span>
    </div>
    <h2 data-testid={testid} className="font-condensed mt-4 text-3xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-4xl lg:text-5xl">
      {title}
    </h2>
  </Reveal>
);
